
// outsource dependencies
import { createBrowserHistory } from 'history';

// export history outside of components to be able dispatch navigation actions from anywhere!
export const history = createBrowserHistory();
